var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M7 0.0180664C5.47604 0.0180664 4.17812 1.00889 3.70052 2.39307H2.33333C1.04635 2.39307 0 3.45811 0 4.76807V16.6431C0 17.953 1.04635 19.0181 2.33333 19.0181H11.6667C12.9536 19.0181 14 17.953 14 16.6431V4.76807C14 3.45811 12.9536 2.39307 11.6667 2.39307H10.2995C9.82187 1.00889 8.52396 0.0180664 7 0.0180664ZM7 2.39307C7.30942 2.39307 7.60616 2.51818 7.82496 2.74088C8.04375 2.96358 8.16667 3.26562 8.16667 3.58057C8.16667 3.89551 8.04375 4.19756 7.82496 4.42026C7.60616 4.64296 7.30942 4.76807 7 4.76807C6.69058 4.76807 6.39383 4.64296 6.17504 4.42026C5.95625 4.19756 5.83333 3.89551 5.83333 3.58057C5.83333 3.26562 5.95625 2.96358 6.17504 2.74088C6.39383 2.51818 6.69058 2.39307 7 2.39307ZM4.66667 9.51807C4.66667 8.88818 4.9125 8.28409 5.35008 7.83869C5.78767 7.39329 6.38116 7.14307 7 7.14307C7.61884 7.14307 8.21233 7.39329 8.64992 7.83869C9.0875 8.28409 9.33333 8.88818 9.33333 9.51807C9.33333 10.148 9.0875 10.752 8.64992 11.1974C8.21233 11.6428 7.61884 11.8931 7 11.8931C6.38116 11.8931 5.78767 11.6428 5.35008 11.1974C4.9125 10.752 4.66667 10.148 4.66667 9.51807ZM2.91667 16.0493C2.91667 14.4091 4.22187 13.0806 5.83333 13.0806H8.16667C9.77812 13.0806 11.0833 14.4091 11.0833 16.0493C11.0833 16.3759 10.8208 16.6431 10.5 16.6431H3.5C3.17917 16.6431 2.91667 16.3759 2.91667 16.0493Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }